import axios from 'axios';

let bearerToken = sessionStorage.getItem('access_token');

let axiosInstanceWithFormData = axios.create({
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
		Authorization: bearerToken,
		'System-Context-Num': 1,
		client_id: 'cas-vault-app'
	},
	withCredentials: true
});

let axiosInstance = axios.create({
	headers: {
		'Content-Type': 'application/json',
		Authorization: bearerToken,
		'System-Context-Num': 1,
		client_id: 'cas-vault-app'
	}
});

let axiosPublicInstance = axios.create({
	headers: {
		'Content-Type': 'application/json'
	}
});

export const makeGetRequest = path => {
	axiosInstance.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstance({
		method: 'get',
		url: path
	});
};

export const makeGetRequestWithQueryParams = (path, params) => {
	axiosInstance.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstance({
		method: 'get',
		url: path,
		params: params
	});
};

export const makePutRequest = (path, data) => {
	axiosInstance.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstance({
		method: 'put',
		url: path,
		data: data
	});
};

export const makePutRequestWithQueryParams = (path, data, params) => {
	axiosInstance.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstance({
		method: 'put',
		url: path,
		data: data,
		params: params
	});
};

export const makePostRequest = (path, data) => {
	axiosInstance.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstance({
		method: 'post',
		url: path,
		data: data
	});
};

export const makePostRequestWithFormData = (path, data) => {
	axiosInstanceWithFormData.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstanceWithFormData({
		method: 'post',
		url: path,
		data: data
	});
};

export const makeDeleteRequest = (path, data) => {
	axiosInstance.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstance({
		method: 'delete',
		url: path,
		data: data
	});
};

export const makeDeleteRequestWithParams = (path, params) => {
	axiosInstance.defaults.headers['Authorization'] = sessionStorage.getItem('access_token');
	return axiosInstance({
		method: 'delete',
		url: path,
		params: params
	});
};

export const makePublicPostRequestWithParams = (path, params) => {
	return axiosPublicInstance({
		method: 'post',
		url: path,
		params: params
	});
};

export const makePublicPutRequestWithParamsAndData = (path, params, data) => {
	return axiosPublicInstance({
		method: 'put',
		url: path,
		params: params,
		data: data
	});
};
